<template>
  <nav
    class="navbar navbar-default"
    style="width:100%"
  >
    <div class="container-fluid">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1" />
          <span class="icon-bar bar2" />
          <span class="icon-bar bar3" />
        </button>
        <a class="navbar-brand" :title="routeName">
          <template v-if="simcard_heading">
            {{ simcard_heading.text }}
            <span class="simcard-profile-status" :class="'simcard-profile-status--' + simcard_heading.color">{{ simcard_heading.status }}</span>
          </template>
          <template v-else>{{ routeName }}</template>
        </a>
      </div>
    </div>
  </nav>
</template>
<script>

import alias from "./alias.json"

export default {
  data () {
    return {
      activeNotifications: false,
      alias: alias
    }
  },
  computed: {
    simcard_heading () {
      if (this.$route.name !== 'simcard_profile_section') return null
      const profile = this.$store.getters.getSimcardProfileById(this.$route.params.simcard_profile_id).profile
      if (!profile) return null
      let text = `${this.translate('simcard_profile.one')}: ${profile.imsi}`
      if (profile.parent_imsi) text += ` (Parent: ${profile.parent_imsi})`
      if (profile.mno_name) text += ` / ${profile.mno_name}`
      return {
        text,
        status: this.translate(this.getTextSimcardProfileStatuses(+profile.status)),
        color: this.getColorSimcardProfileStatuses(+profile.status)
      }
    },
    routeName () {
      if (this.simcard_heading) return `${this.simcard_heading.text} ${this.simcard_heading.status}`
      switch (this.$route.name) {
        case 'device_section':
        case 'device_section_zero':
          let dev = this.$store.getters._getDeviceById(this.$route.params.device_id);
          if (dev) {
            return this.translate('device.one') + ': ' + this.$route.params.device_id + '(' + dev.name + ')'
          } else {
            return this.translate('device.one') + ': ' + this.$route.params.device_id
          }

        case 'device_list_group':
          return this.translate('device.list_group') + ': ' + this.$store.getters.getDeviceGroupById(this.$route.params.device_group_id).name

        case "simcard_devices_section":
          return this.translate('simcard_devices.one') + ': ' + this.$route.params.simcard_devices_id

        case "simcard_devices_group":
          return this.translate('simcard_devices.list_group') + ': ' + this.$store.getters.getSimcardDevicesGroupById(this.$route.params.simcard_devices_group_id).name

        case "simcard_profile_section":
        case "esim_profile_section":
          let title = ""
          let profile = {}
          if (this.$route.name === "simcard_profile_section") {
            title = this.translate('simcard_profile.one')
            profile = this.$store.getters.getSimcardProfileById(this.$route.params.simcard_profile_id).profile
          } else if (this.$route.name === "esim_profile_section") {
            title = this.translate('esim_profile.one')
            profile = this.$store.getters.getEsimProfileById(this.$route.params.esim_profile_id).profile
          }

          if (profile) {
            if (profile.parent_imsi) {
              title += `:${profile.imsi} (Parent: ${profile.parent_imsi}`
            } else {
              title += `: ${profile.imsi} ${this.translate(this.getTextSimcardProfileStatuses(+profile.status))}`
            }
          }

          return title

        case "tariffed_device_section":
          let tariffed_device = this.$store.getters.getSelectedTariffedDevice
          if (tariffed_device){
            const device_name = `${tariffed_device.fid} / ${tariffed_device.device_name}`
            const date_start = tariffed_device.date_start.split("-")
            const new_date_start = `${date_start[2]}-${date_start[1]}-${date_start[0]}`

            return `${this.translate('tariffed_device.tariffication')} : ${device_name} c ${new_date_start}`
          } else {
            return this.translate('tariffed_device.one')
          }

        case "client_request_section":
          let client_request = this.$store.getters.getSelectedClientRequest
          if (client_request){
            const device_name = `${client_request.device.fid} / ${client_request.device.name}`
            const new_type = this.$store.getters.getClientRequestsInfo.types.find((type) => {
              if (client_request.type === type.id) return type
            }).title

            return `${this.translate('client_request.navbar_one')} ${this.translate('client_request.navbar_types.' + new_type)} ${device_name}`
          } else {
            return this.translate('client_request.one')
          }

        case "client_section":
          let client = this.$store.getters.getSelectedClient
          if (client){
            return `${this.translate('client.one')}: ${client.name}`
          } else {
            return this.translate('client.one')
          }

        case "apn_section":
          let apn = this.$store.getters.getSelectedApn
          if (apn){
            return `${this.translate('apn_list.apn')}: ${apn.mno_name} / ${apn.apn}`
          } else {
            return this.translate('apn_list.apn')
          }

        case "tariff_section":
          let tariff = this.$store.getters.getSelectedTariff
          if (tariff){
            return `${this.translate('tariff.one')}: ${tariff.name}`
          } else {
            return this.translate('tariff.one')
          }

        case "user_section":
          let user = this.$store.getters.getSelectedUser
          if (user){
            return `${this.translate('user.one')}: ${user.name}`
          } else {
            return this.translate('user.one')
          }

        case "invoice_section":
          let invoice = this.$store.getters.getSelectedInvoice
          if (invoice){
            return `${this.translate('invoice.one')} № ${invoice.invoice_number} ${invoice.invoice_name} ${this.translate('for')} ${invoice.date_period}`
          } else {
            return this.translate('invoice.one')
          }

        case "ticket_section":
          let ticket = this.$store.getters.getSelectedTicket
          if (ticket){
            return `${this.translate('ticket.one')} #${ticket.id}`
          } else {
            return this.translate('ticket.one')
          }

        case "client_order_section":
          let client_order = this.$store.getters.getSelectedClientOrder
          if (client_order){
            return `${this.translate('client_order.title')} №${client_order.id}`
          } else {
            return this.translate('client_order.title')
          }


        default:
          if (this.alias[this.$route.name] !== undefined) {
            return this.translate(this.alias[this.$route.name])
          }

          return ''
      }
    }
  },
  methods: {
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    }
  }
}

</script>
<style>
.navbar-header .navbar-toggle {
  margin: 10px 0 10px 0;
  width: 40px;
  height: 40px;
  @media (max-width: 767px) {
    margin: 10px 10px 10px 0;
  }
}

</style>
